import React from 'react';
import { OptionProps, SelectProps } from 'antd/lib/select';
import { Select, Option } from 'components';

export interface MultiSelectOption extends OptionProps {
	key?: number | string;
	disabled?: boolean;
}

export interface MultiSelectProps extends Omit<SelectProps<any>, 'options'> {
	onChange?: (value: any) => void;
	options: Partial<MultiSelectOption>[];
	shouldDisableOptions?: boolean;
}

const MultiSelect: React.FC<MultiSelectProps & { byKey?: boolean }> = props => {
	const { options, mode, byKey = false, shouldDisableOptions = false, ...restOfProps } = props;

	return (
		<div className="select-wrapper bringg-multiselect">
			<Select {...restOfProps} optionFilterProp="children" mode={mode || 'multiple'}>
				{options.map((option, index) => (
					<Option
						key={option.key || index.toString()}
						value={byKey ? option.key : option.value}
						disabled={shouldDisableOptions ? option.disabled : false}
						data-test-id={option.key}
					>
						{option.children || option.value}
					</Option>
				))}
			</Select>
		</div>
	);
};

export default MultiSelect;
